import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/komunalakranj_racun_odjemnomesto.jpg'


const _hoisted_1 = { class: "userDashboard" }
const _hoisted_2 = { class: "grayBoxInfo" }
const _hoisted_3 = { class: "info-input" }
const _hoisted_4 = { class: "p-float-label waste-location-input error-label" }
const _hoisted_5 = { for: "location" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "p-float-label error-label" }
const _hoisted_8 = { for: "phone" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "info-switch" }
const _hoisted_11 = { class: "info-switch-content" }
const _hoisted_12 = { class: "note" }
const _hoisted_13 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_14 = ["alt"]
const _hoisted_15 = { class: "verificationStatus" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_check-round icon" }, null, -1)
const _hoisted_17 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_SidebarUserWrapper = _resolveComponent("SidebarUserWrapper")!

  return (_openBlock(), _createBlock(_component_SidebarUserWrapper, {
    title: _ctx.$t('user.my_waste'),
    sidebarComponent: _ctx.sidebarComponent
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t("my_waste.sub_title")), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, [
            _createVNode(_component_InputText, {
              id: "location",
              type: "text",
              modelValue: _ctx.form.om_type,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.om_type) = $event)),
              name: "location",
              maxlength: "30"
            }, null, 8, ["modelValue"]),
            _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("my_waste.waste_location")), 1),
            _createElementVNode("i", {
              class: "icon-warpit_icon_info",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showInfoDialog = true))
            }),
            (_ctx.errors.om_type_error)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.errors.om_type_error), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("span", _hoisted_7, [
            _createVNode(_component_InputText, {
              id: "phone",
              type: "text",
              modelValue: _ctx.form.phone,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.phone) = $event)),
              name: "phone",
              maxlength: "30"
            }, null, 8, ["modelValue"]),
            _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("my_waste.phone")), 1),
            (_ctx.errors.phone_error)
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.errors.phone_error), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_InputSwitch, {
              modelValue: _ctx.form.sms_notifications,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.sms_notifications) = $event)),
              class: "info-input-switch"
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t("my_waste.content_title")), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("my_waste.content_subtitle")), 1)
            ])
          ]),
          _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t("my_waste.service")), 1),
          _createVNode(_component_Button, {
            class: "defaultButton",
            label: _ctx.$t(`my_waste.save`),
            onClick: _ctx.saveSettings
          }, null, 8, ["label", "onClick"]),
          (_ctx.errors.response_error)
            ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.errors.response_error), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_component_Dialog, {
        visible: _ctx.showInfoDialog,
        "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showInfoDialog) = $event)),
        class: "confirmationDialog info-dialog"
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: _imports_0,
            alt: _ctx.$t('accessibility.waste.place_of_purchase')
          }, null, 8, _hoisted_14)
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_Dialog, {
        visible: _ctx.showUpdateSuccessfulDialog,
        "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showUpdateSuccessfulDialog) = $event)),
        class: "successDialog"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t("consents.successful")), 1)
          ]),
          _createElementVNode("button", {
            class: "defaultButton",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showUpdateSuccessfulDialog = false))
          }, _toDisplayString(_ctx.$t("dialog.close")), 1)
        ]),
        _: 1
      }, 8, ["visible"])
    ]),
    _: 1
  }, 8, ["title", "sidebarComponent"]))
}